import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/lib/site";
import Logo from "@/components/Logo";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 bg-white ${scrolled ? "border-b border-[#EAEAEA] shadow-[0_1px_0_rgba(0,0,0,0.02)]" : ""}`}
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 h-[88px] flex items-center justify-between">
        <Link to="/" onClick={() => setOpen(false)} data-testid="header-logo-link">
          <Logo height={72} />
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className="text-[14px] font-medium text-[#0F1115]"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {({ isActive }) => (
                <span
                  className="link-underline"
                  data-active={isActive ? "true" : "false"}
                >
                  {n.label}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={SITE.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="bg-[#25D366] text-white rounded-full px-5 py-2.5 font-bold text-sm hover:bg-[#1EBE57] hover:-translate-y-0.5 hover:shadow-lg transition-all inline-flex items-center gap-2"
            data-testid="header-whatsapp-cta"
          >
            <WhatsAppIcon size={16} /> Chat
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 -mr-2 text-[#0F1115]"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#EAEAEA] bg-white" data-testid="mobile-nav">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-[15px] font-medium ${isActive ? "bg-[#FFF9E6] text-[#0F1115]" : "text-[#0F1115]"}`
                }
                data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-3 bg-[#25D366] text-white rounded-full px-5 py-3 font-bold text-sm text-center inline-flex items-center justify-center gap-2"
              data-testid="mobile-whatsapp-cta"
            >
              <WhatsAppIcon size={16} /> Chat
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
